/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { Calendar, ArrowUpRight } from "lucide-react";
import StatusBadge from "../StatusBadge";

const LatestBookingsTable = ({ bookings, onViewAll }) => {
  return (
    <div className="bg-slate-900 rounded-2xl sm:rounded-3xl border border-slate-800 shadow-sm overflow-hidden text-white">
      <div className="p-4 sm:p-6 border-b border-slate-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-2 sm:gap-3">
          <h3 className="font-bold text-sm sm:text-base lg:text-lg">
            Latest Bookings
          </h3>
          <span className="text-xs px-2 py-1 bg-blue-500/20 text-blue-300 rounded border border-blue-500/30">
            Time-filtered
          </span>
        </div>
        <button
          onClick={onViewAll}
          className="text-blue-400 text-xs sm:text-sm font-medium hover:text-blue-300 hover:underline flex items-center gap-1 px-3 py-1.5 hover:bg-blue-500/10 rounded-lg transition-colors"
        >
          View All <ArrowUpRight size={14} className="sm:w-4 sm:h-4" />
        </button>
      </div>

      {/* Desktop Table (hidden on mobile) */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-800/50 text-white/70 uppercase font-semibold">
            <tr>
              <th className="px-6 py-4">Caregiver</th>
              <th className="px-6 py-4">Client</th>
              <th className="px-6 py-4">Service</th>
              <th className="px-6 py-4">Date</th>
              <th className="px-6 py-4">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700">
            {bookings.map((bk) => (
              <tr
                key={bk.id}
                className="hover:bg-slate-800/50 transition-colors"
              >
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img
                      src={bk.avatar}
                      alt={bk.caregiver}
                      className="w-8 h-8 rounded-full object-cover bg-slate-700 flex-shrink-0"
                    />
                    <span className="font-bold">{bk.caregiver}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-white/70">{bk.client}</td>
                <td className="px-6 py-4">
                  <span className="px-2.5 py-1 bg-slate-700 rounded-lg text-xs font-medium text-white/70">
                    {bk.type}
                  </span>
                </td>
                <td className="px-6 py-4 text-white/60">{bk.date}</td>
                <td className="px-6 py-4">
                  <StatusBadge status={bk.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards (visible on mobile) */}
      <div className="md:hidden divide-y divide-slate-700">
        {bookings.map((bk) => (
          <div
            key={bk.id}
            className="p-4 hover:bg-slate-800/50 transition-colors"
          >
            <div className="flex items-start gap-3">
              <img
                src={bk.avatar}
                alt={bk.caregiver}
                className="w-10 h-10 rounded-full object-cover bg-slate-700 flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                {/* Updated header section with better spacing */}
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between items-start gap-2">
                    <div className="min-w-0">
                      <h4 className="font-bold text-sm truncate">
                        {bk.caregiver}
                      </h4>
                      <p className="text-white/60 text-xs mt-0.5 truncate">
                        Client: {bk.client}
                      </p>
                    </div>
                    {/* Status badge with fixed width on mobile */}
                    <div className="flex-shrink-0">
                      <StatusBadge status={bk.status} />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <p className="text-xs text-white/60 uppercase font-semibold">
                        Service
                      </p>
                      <span className="inline-block mt-1 px-2 py-1 bg-slate-700 rounded-lg text-xs font-medium text-white/70 truncate max-w-full">
                        {bk.type}
                      </span>
                    </div>
                    <div>
                      <p className="text-xs text-white/60 uppercase font-semibold">
                        Date
                      </p>
                      <p className="mt-1 text-sm text-white/70 truncate">
                        {bk.date}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {bookings.length === 0 && (
        <div className="text-center py-8">
          <Calendar className="w-12 h-12 text-white/40 mx-auto mb-3" />
          <p className="text-white/60">No bookings found for this period</p>
        </div>
      )}
    </div>
  );
};

export default LatestBookingsTable;
